document.addEventListener("DOMContentLoaded", function () {
  if (!window.jQuery || !jQuery.fn.slick) return;

  document.querySelectorAll(".landing-slick").forEach((el) => {
    const $el = jQuery(el);

    if ($el.hasClass("slick-initialized")) return;

    $el.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: true,
      dots: true,
      arrows: true,
      infinite: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            variableWidth: false,
            arrows: false,
          }
        },
      ]
    });
  });


  document.querySelectorAll(".slider-container__items").forEach((el) => {
    const $el = jQuery(el);

    if ($el.hasClass("slick-initialized")) return;

    $el.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: true,
      dots: true,
      arrows: false,
      infinite: true,
      variableWidth: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: false,
          }
        },
      ]
    });
  });

  document.querySelectorAll(".teachers-slider").forEach((el) => {
    const $el = jQuery(el);

    if ($el.hasClass("slick-initialized")) return;

    $el.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "0px",
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: true,
      arrows: true,
      prevArrow: '<button type="button" class="teachers-arrow teachers-prev"></button>',
      nextArrow: '<button type="button" class="teachers-arrow teachers-next"></button>',
      dots: true,
      variableWidth: true,

      // 👇 Dots con imagen
      customPaging: function (slider, i) {

        const slide = slider.$slides.eq(i);
        const img = slide.find("img").attr("src");

        return `
        <button class="thumb-dot">
          <img src="${img}" />
        </button>
      `;
      },

      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: false,
            centerMode: false,
            slidesToShow: 1
          }
        }
      ]
    });
  });
});
